/**
 * For Ausbiz specifically, this is always going to be just
 * 'en', but putting 'en' in an array just to be safe.
 */
const ALL_POSSIBLE_LANGUAGES = ["en"];
// Matching the format:     // /{"(en|ar)"\:(.*?)}/gi
const BRACKETS_REGEX = new RegExp(`{"${ALL_POSSIBLE_LANGUAGES.join("|")}"\:(.*?)}`, "gi");

/**
 * Please see bottom of file for example input and output
 * TODO there is almost certainly a more efficient way to do this
 * 
 * @param {*} content Response from one of the APIs
 * @param {*} language "en", "fr", "ar" etc.
 * 
 */
export const getContentWithLanguage = (content, language) => {
	for (let key in content) {
		if (content[key] && typeof content[key] === "object") {
		  if (content[key].hasOwnProperty(language)) {
			content[key] = content[key][language];
		  } else {
			getContentWithLanguage(content[key], language);
		  }
		}
	  }
	  return content;
}

/**

getContentWithLanguage() function input and output

Example input:
 [{
	"id": 1,
	"name": {
		"en": "Company News",
		"fr": "Actualités Entreprise"
	},
	"navLabel": {
		"en": "Company",
		"fr": "Entreprise"
	},
	"tierInUrl": {
		"en": "/company",
		"fr": "/entreprise"
	},
	"firstChildList": [{
		"id": 3,
		"name": {
			"en": "Companies Taxonomy",
			"fr": "Nomenclature Entreprises"
		},
		"navLabel": null,
		"tierInUrl": {
			"en": "/company-news---corporate-news/companies-taxonomy",
			"fr": "/actualites-entreprise---actualites-business/nomenclature-entreprises"
		},
		"description": {
			"en": "<p>Companies Taxonomy Description<br></p>",
			"fr": "<p>Description Nomenclature Entreprise<br></p>"
		},
		"metaDescription": null
	}]
}, {
	"id": 2,
	"name": {
		"en": "Markets",
		"fr": "Marchés"
	},
	"navLabel": {
		"en": "Markets",
		"fr": "Marchés"
	},
	"tierInUrl": {
		"en": "/markets",
		"fr": "/marches"
	},
	"firstChildList": []
}]


Example Output (with parameter 'language' = "en"):

[{
	"id": 1,
	"name": "Company News",
	"navLabel": "Company",
	"tierInUrl": "/company",
	"firstChildList": [{
		"id": 3,
		"name": "Companies Taxonomy",
		"navLabel": null,
		"tierInUrl": "/company-news---corporate-news/companies-taxonomy",
		"description": "<p>Companies Taxonomy Description<br></p>",
		"metaDescription": null
	}]
}, {
	"id": 2,
	"name": "Markets",
	"navLabel": "Markets",
	"tierInUrl": "markets",
	"firstChildList": []
}]

 */